import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getToken } from "../lib/api";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
